import React from "react";
import { Navigate } from "react-router-dom";

// Dashboard
import GeneralDashboard from "../pages/Dashboard";
import LTDashboard from "../pages/lucky-target/Dashboard";
import LT1Dashboard from "../pages/lucky-target-1/Dashboard";
import LT3Dashboard from "../pages/lucky-target-3/Dashboard";
import RODashboard from "../pages/american-roulette/Dashboard";
import SODashboard from "../pages/sorat/Dashboard";

// Profile
import UserProfile from "../pages/Authentication/userProfile";

// Authentication pages
import Basic404 from "../pages/Authentication/Basic404.js";
import Login from "../pages/Authentication/Login";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Logout from "../pages/Authentication/Logout";
import ResetPasswordForm from "../pages/Authentication/ResetPassword.js";
import Users from "../pages/Users/index.js";
import JokerSettings from "../pages/lucky-target/Joker/index.js"; // LT Only
import LTPnL from "../pages/lucky-target/Reports/PnL";
import LT1PnL from "../pages/lucky-target-1/Reports/PnL";
import LT3PnL from "../pages/lucky-target-3/Reports/PnL";
import ROPnL from "../pages/american-roulette/Reports/PnL";
import SOPnL from "../pages/sorat/Reports/PnL";

import JokerHistory from "../pages/lucky-target/Reports/JokerHistory";
import DayReport from "../pages/Reports/DayReport";
import Withdrawal from "../pages/Withdrawal/index.js";
import Operators from "../pages/Operators/index.js";
import Settings from "../pages/Settings/index.js";

const authProtectedRoutes = [
  // Redirect Default to General Dashboard
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  {
    path: "/dashboard",
    component: <GeneralDashboard />,
  },

  // --- Lucky Target (Game 1) ---
  { path: "/lucky-target/dashboard", component: <LTDashboard /> },
  { path: "/lucky-target/joker", component: <JokerSettings /> },
  { path: "/lucky-target/transactions", component: <LTPnL /> },

  // --- Lucky Target 2 (Game 2) ---
  { path: "/lucky-target-1/dashboard", component: <LT1Dashboard /> },
  { path: "/lucky-target-1/transactions", component: <LT1PnL /> },

  // --- Lucky Target 2 / LT3 (Game 5) ---
  { path: "/lucky-target-3/dashboard", component: <LT3Dashboard /> },
  { path: "/lucky-target-3/transactions", component: <LT3PnL /> },
  { path: "/lucky-target-2/dashboard", component: <LT3Dashboard /> },
  { path: "/lucky-target-2/transactions", component: <LT3PnL /> },

  // --- American Roulette (Game 3) ---
  { path: "/american-roulette/dashboard", component: <RODashboard /> },
  { path: "/american-roulette/transactions", component: <ROPnL /> },

  // --- Sorat (Game 4) ---
  { path: "/sorat/dashboard", component: <SODashboard /> },
  { path: "/sorat/transactions", component: <SOPnL /> },
  // Reusing LT1 PnL if it's generic enough, otherwise I might need RO PnL

  // Common
  { path: "/profile", component: <UserProfile /> },
  { path: "/lucky-target/users", component: <Users gameType="lt" /> },
  { path: "/lucky-target-1/users", component: <Users gameType="lt1" /> },
  { path: "/lucky-target-3/users", component: <Users gameType="lt3" /> },
  { path: "/lucky-target-2/users", component: <Users gameType="lt3" /> },
  { path: "/american-roulette/users", component: <Users gameType="ro" /> },
  { path: "/sorat/users", component: <Users gameType="so" /> },
  { path: "/users", component: <Navigate to="/lucky-target/users" /> }, // Fallback

  // Withdrawal
  { path: "/withdrawal", component: <Withdrawal /> },
  { path: "/day-report", component: <DayReport /> },

  // Operators
  { path: "/operators", component: <Operators /> },

  // Settings
  { path: "/settings", component: <Settings /> },

  // Legacy / Fallbacks (Redirect or Keep)
  { path: "/joker", component: <Navigate to="/lucky-target/joker" /> },
  { path: "/transactions", component: <Navigate to="/lucky-target/transactions" /> },
  { path: "/pnl", component: <Navigate to="/lucky-target/transactions" /> },
  // JokerHistory seems specific to LT Joker result history? 
  { path: "/joker-history", component: <JokerHistory /> },

  { path: "*", component: <Navigate to="/404" /> },
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/reset-password", component: <ResetPasswordForm /> },
  { path: "/404", component: <Basic404 /> },
];

export { authProtectedRoutes, publicRoutes };
